<template>
    <div>
        <div v-if="axios_errored == false">
            <div v-for="data in page_api_data" :key="data.id"
                class="wordpress-page-api-content"
                v-html="data.content.rendered">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        base_api_url: {
            type: String,
            required: true,
        },
        page_slug: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            page_api_data: false,
            axios_errored: false
        }
    },
    beforeMount() {
        /**
         * Make request to Wordpress API to get the page data of the corresponding slug passed in as a prop.
         */
        axios.get(`${this.base_api_url}/wp-json/wp/v2/pages?slug=${this.page_slug}`)
            .then(response => {
                this.page_api_data = response.data
            })
            .catch(error => {
                this.axios_errored = true
                console.log('No Wordpress page content found')
            })
    }
}
</script>